var OrganizationForResponse;

import OrganizationMixin from 'trunks/vue/share/components/fields/organization.js';

import FieldMixinForResponse from './mixin.js';

import PopoverGroupOptionsSelect from 'trunks/vue/share/components/popover_group_options_select.js';

export default OrganizationForResponse = {
  mixins: [FieldMixinForResponse, OrganizationMixin],
  components: {
    'popove-option-select': PopoverGroupOptionsSelect
  },
  template: `<Field :field='field'
       v-show='visible'
       :extendClass='[fieldCommonClass, fieldDifferenceClass]'
       :message='errorMsg'>
  <template slot='input'>
    <template v-if="!editing">
      <template v-if='value'>
        <div class="chip">{{ value.name }}</div>
      </template>
      <div class="placeholder" v-else>未填写</div>
    </template>
    <popove-option-select v-else
                         extendClass='organization-select'
                         :remote="queryUrl"
                         :initialSelectedOptions="initValue"
                         @submitClicked='update'>
      <template slot='trigger' slot-scope='{ options }'>
        <div class="chip-input-container justify-box">
          <span class="chip" v-for='option in options' :key='option.id'>
            <span class="text-ellipsis">{{ option.name }}</span>
          </span>
          <div class="content placeholder">请选择</div>
        </div>
        <i class="slp-caret-down"></i>
      </template>
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='content'>
          <div class='user-item small'>
            <span class='name'>{{ option.name }}</span>
          </div>
        </div>
        <i class='tip' :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
      </template>
      <div slot='filter-blankslate' class="list-group-name">没有组织</div>
      <div slot='options-blankslate' class="list-group-name">没有组织</div>
    </popove-option-select>
  </template>
</Field>`,
  computed: {
    initValue: function() {
      if (this.value) {
        return [this.value];
      } else {
        return [];
      }
    },
    queryUrl: function() {
      return `/namespaces/${currentNamespace.id}/user/organizations`;
    }
  },
  methods: {
    update: function(newValue) {
      return this.valueChange(newValue[0] || null);
    }
  }
};
